var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56241 0.117538C2.5105 0.783547 0.200472 2.39953 0.0383627 3.84544C-0.711647 10.2916 9.70848 20.7117 16.1525 19.9617C17.6105 19.7997 19.2206 17.4918 19.8825 16.4378C19.9748 16.2917 20.0145 16.1188 19.9953 15.9472C19.976 15.7756 19.8989 15.6157 19.7765 15.4938L16.8865 12.5998C16.7434 12.4555 16.5487 12.3743 16.3455 12.3743C16.1424 12.3743 15.9476 12.4555 15.8045 12.5998L14.1785 14.2459C13.9965 14.4279 13.8546 14.5638 13.7465 14.6458C12.3904 14.7898 9.85856 13.9817 7.9264 12.0458C5.9943 10.1098 5.18836 7.58177 5.32633 6.22354C5.42231 6.11556 5.55429 5.97549 5.73633 5.79357L7.38843 4.19952C7.53226 4.0561 7.61304 3.86149 7.61304 3.65851C7.61304 3.45554 7.53226 3.26076 7.38843 3.1175L4.50835 0.225433C4.38656 0.102385 4.2264 0.0245372 4.05438 0.00486551C3.88237 -0.0146662 3.70882 0.024955 3.56234 0.117449L3.56241 0.117538Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.e84e7f5b6e99543e593a30232ff04ef2.svg";
export { ForwardRef as ReactComponent };